import { Link } from "react-router-dom";
import { btn } from "../../../../../../components/Button/buttonStyles";

const Field = ({ label, value }) => {
  const isEmpty = value === null || value === undefined || value === "";
  return (
    <div className="flex items-start text-sm">
      <span className="w-44 shrink-0 text-xs font-medium text-gray-500 pt-px">
        {label}:
      </span>
      <span className="text-gray-900">{isEmpty ? "—" : value}</span>
    </div>
  );
};

const SectionTitle = ({ children }) => (
  <h3 className="text-xs font-semibold text-gray-500 uppercase tracking-wider mb-2">
    {children}
  </h3>
);

const btnPrimary = btn("primary", "sm");
const btnDanger = btn("danger", "sm");

const JobDetailsInfoCard = ({
  job,
  onDownloadPO,
  onClone,
  onUpdate,
  onDelete,
}) => {
  const formatDateTime = (dateStr) => {
    if (!dateStr) return "—";
    const d = new Date(dateStr);
    return d.toLocaleString("en-IN", {
      day: "2-digit",
      month: "short",
      year: "numeric",
      hour: "2-digit",
      minute: "2-digit",
    });
  };

  const getLanguagePair = () => {
    if (!job?.languagePair) return "—";
    return `${job.languagePair.sourceLanguage?.name || ""} → ${
      job.languagePair.targetLanguage?.name || ""
    }`;
  };

  return (
    <section>
      <div className="flex justify-between items-center mb-3 flex-wrap gap-3">
        <h2 className="text-xl font-bold text-gray-900">
          Job <span className="text-gray-500 font-medium">J{job?.id || "—"}</span>
        </h2>
        <div className="flex items-center gap-2 text-sm flex-wrap">
          <button onClick={onDownloadPO} className={btnPrimary}>Download PO</button>
          <button onClick={onClone} className={btnPrimary}>Clone</button>
          <button onClick={onUpdate} className={btnPrimary}>Update</button>
          <button onClick={onDelete} className={btnDanger}>Delete</button>
        </div>
      </div>

      <div className="bg-white border border-gray-100 shadow-sm rounded-lg p-5 space-y-5">
        <div>
          <SectionTitle>Requirements</SectionTitle>
          <div className="space-y-3">
            <Field label="Name" value={job?.name} />
            <Field label="Service" value={job?.service?.name} />
            <Field label="Language pair" value={getLanguagePair()} />
            <Field label="Project specialization" value={job?.project?.specialization?.name} />
            <Field label="Deadline at" value={formatDateTime(job?.deadline_at)} />
          </div>
        </div>

        <div>
          <SectionTitle>Setup</SectionTitle>
          <div className="space-y-3">
            <Field
              label="Auto start on vendor acceptance"
              value={job?.auto_start_on_vendor_acceptance ? "Yes" : "No"}
            />
            <Field
              label="Checklist"
              value={
                job?.checklist?.name ? (
                  <Link
                    to={`/checklists/${job.checklist.id}`}
                    className="text-brand-600 hover:text-brand-800 underline font-medium"
                  >
                    {job.checklist.name}
                  </Link>
                ) : (
                  ""
                )
              }
            />
            <Field label="Instructions" value={job?.instructions} />
          </div>
        </div>

        <div>
          <SectionTitle>Other details</SectionTitle>
          <div className="space-y-3">
            <Field label="Legal entity" value={job?.legal_entity} />
            <Field
              label="Job PO PDF template"
              value={job?.pdf_template_id ? `Template ${job.pdf_template_id}` : ""}
            />
            <Field label="Internal note" value={job?.internal_note} />
          </div>
        </div>
      </div>
    </section>
  );
};

export default JobDetailsInfoCard;
